import { render, staticRenderFns } from "./PDFPageV2.vue?vue&type=template&id=708b8353&scoped=true&"
import script from "./PDFPageV2.vue?vue&type=script&lang=js&"
export * from "./PDFPageV2.vue?vue&type=script&lang=js&"
import style0 from "./PDFPageV2.vue?vue&type=style&index=0&id=708b8353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b8353",
  null
  
)

export default component.exports